import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=b7936308&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7936308')) {
      api.createRecord('b7936308', component.options)
    } else {
      api.reload('b7936308', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=b7936308&", function () {
      api.rerender('b7936308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tpc7p8uUx4W3/JS/comp/openstreetmap.vue"
export default component.exports